import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CompanyEffects } from './company.effects';
import { CompanyNamespace, CompanyReducer } from './company.store';

@NgModule({
  imports: [
    StoreModule.forFeature(CompanyNamespace, CompanyReducer),
    EffectsModule.forFeature([CompanyEffects]),
  ],
})
export class CompanyDataModule {}
